/*
 *
 * Package: `@dbh/hotel-user-ratings-theme`.
 *
 */const HOTEL_USER_RATINGS_THEME_KEY="HotelUserRatings";const modifyHotelUserRatingsTheme=a=>{let{spacing:{sp2:b,sp3:c,sp5:d,sp8:e},fonts:{size:{ff7:f}}}=a;return {[HOTEL_USER_RATINGS_THEME_KEY]:{fontSize:f,height:"unset",averageTextPadding:{padding:"0 "+b,desktopPadding:"0 "+c},description:{margin:{xs:"0 "+d+" 0 "+c,sm:"0 "+e+" 0 "+c}}}}};

export { HOTEL_USER_RATINGS_THEME_KEY, modifyHotelUserRatingsTheme as default };
